import React from "react";
import { Play, Film } from "lucide-react";

export default function ProductDemo() {
  return (
    <section
      id="demo"
      data-testid="product-demo-section"
      className="relative py-28 md:py-40 border-t border-white/5 overflow-hidden"
    >
      <div className="pointer-events-none absolute top-20 left-1/3 w-[600px] h-[400px] glow-purple opacity-30" />
      <div className="pointer-events-none absolute bottom-20 right-0 w-[500px] h-[400px] glow-teal opacity-25" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 mb-5">
            <Film className="w-3.5 h-3.5 text-[#3DDFB3]" />
            <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#3DDFB3]">
              ── Product demo
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
            Watch AI CRM{" "}
            <span className="italic">in motion.</span>
          </h2>
          <p className="mt-6 text-white/60 text-lg max-w-2xl">
            Three minutes that show how we take a single WhatsApp message, fan
            it out across tools, and close the loop with the customer — all
            without a human in the middle.
          </p>
        </div>

        <div
          className="relative rounded-[24px] overflow-hidden border border-white/10 bg-[#0b0b13]"
          data-testid="demo-video-frame"
        >
          {/* frame chrome */}
          <div className="flex items-center justify-between px-5 py-3 border-b border-white/5 bg-white/[0.02]">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-[#ef4444]/80" />
              <span className="w-2.5 h-2.5 rounded-full bg-[#f59e0b]/80" />
              <span className="w-2.5 h-2.5 rounded-full bg-[#22c55e]/80" />
            </div>
            <div className="text-[11px] font-mono tracking-[0.14em] uppercase text-white/50 flex items-center gap-2">
              <Play className="w-3 h-3 text-[#7C5CFF]" />
              Flingy CRM / product-walkthrough
            </div>
            <div className="text-[11px] font-mono text-white/40">3:14</div>
          </div>

          {/* Video */}
          <div className="relative aspect-video bg-black">
            <iframe
              data-testid="demo-video-iframe"
              title="AI CRM Product Demo"
              src="https://watchclueso.com/embed/itx4ixnrz9gwpj9e"
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          {/* Glow accent */}
          <div className="pointer-events-none absolute -bottom-10 left-1/2 -translate-x-1/2 w-4/5 h-20 glow-purple opacity-50" />
        </div>

        {/* bullets underneath */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {[
            {
              k: "01",
              t: "Inbound across channels",
              d: "WhatsApp, Instagram, Email and Voice all land in one thread-aware inbox.",
            },
            {
              k: "02",
              t: "Agents + flows decide",
              d: "A classifier picks intent, routes through conditions, and hits the right tool.",
            },
            {
              k: "03",
              t: "Close the loop",
              d: "Update CRM, notify the customer, and escalate only when truly needed.",
            },
          ].map((b, i) => (
            <div key={i} className="card-surface p-6" data-testid={`demo-step-${i}`}>
              <div className="font-serif text-3xl text-white/25 mb-2">{b.k}</div>
              <div className="text-[15px] font-medium text-white mb-1.5">
                {b.t}
              </div>
              <p className="text-[13.5px] text-white/55 leading-relaxed">{b.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
